import * as FormaUhrady from 'mc/lib/api/gen/proxioapi/FormaUhrady';
import * as TypDokladuPlatby from 'mc/lib/api/gen/proxioapi/TypDokladuPlatby';

const captions = {
    [FormaUhrady.HOTOVE]: 'Hotově',
    [FormaUhrady.BANK_PREVOD]: 'Převodem',
    [FormaUhrady.PLAT_KARTA]: 'Platební karta',
};

export function getCaption(typ) {
    return captions[typ];
}

const typDokladuCaptions = {
    [TypDokladuPlatby.POK]: "Hotově",
    [TypDokladuPlatby.BAN]: "Bankovním převodem",
    [TypDokladuPlatby.KAR]: "Platební karta",
};

export function getCaptionForTypDokladu(typ) {
    return typDokladuCaptions[typ];
}
